export default __webpack_public_path__ + "static/media/azrx.12e74979.svg";